import { FormattedMessage, useIntl } from 'react-intl';
import appMessages from '~/containers/App/messages';
import { useSnackbar } from '~/containers/Snackbar/SnackbarContext';
import { useRoutes } from '~/hooks/api/useRoutes';
import { usePublisherMe } from '~/hooks/api/usePublisherMe';
import {
  toRoutePreferenceValue,
  useRoutePreferences,
  useSaveRoutePreference,
} from '~/hooks/api/useRoutePreferences';
import { RoutePreferenceSettingsForm } from './form';
import messages from './messages';

const RoutePreferenceSettings = () => {
  const intl = useIntl();
  const { showSnackbar } = useSnackbar();
  const publisherQuery = usePublisherMe();
  const routeQuery = useRoutes();
  const publisherId = publisherQuery.data?.id;
  const preferencesQuery = useRoutePreferences(publisherId);
  const saveMutation = useSaveRoutePreference(publisherId, {
    onError: () => {
      showSnackbar({
        message: intl.formatMessage(
          messages.saveRoutePreferenceSettingsFailure
        ),
      });
    },
  });

  if (
    routeQuery.isLoading ||
    preferencesQuery.isLoading ||
    !preferencesQuery.data ||
    !routeQuery.data
  ) {
    return <FormattedMessage {...appMessages.loading} />;
  }

  const activeRoutes = routeQuery.data.filter((route) => !route.isSuspended);
  const preferences = preferencesQuery.data;

  const rows = activeRoutes.map((route) => ({
    routeId: route.id,
    name: route.name,
    value: toRoutePreferenceValue(
      preferences.find((p) => p.routeId === route.id)
    ),
  }));

  const pendingRouteId = saveMutation.isPending
    ? saveMutation.variables?.routeId
    : undefined;

  return (
    <RoutePreferenceSettingsForm
      rows={rows}
      pendingRouteId={pendingRouteId}
      onChange={(variables) => saveMutation.mutateAsync(variables)}
    />
  );
};

export default RoutePreferenceSettings;
